const routeMap = {
  'a': '/login',
  'b': '/dashboard',
  'c': '/users',
  'd': '/roles',
  'e': '/organizations',
  'f': '/permissions',
  'g': '/logs'
}

const reverseMap = {}
Object.keys(routeMap).forEach(key => {
  reverseMap[routeMap[key]] = key
})

export function encodePath(path) {
  const pathWithoutSlash = path.startsWith('/') ? path.slice(1) : path
  const parts = pathWithoutSlash.split('/')
  
  if (parts.length === 1) {
    const key = Object.keys(routeMap).find(k => routeMap[k] === '/' + parts[0])
    return key || path
  }
  
  const firstPart = parts[0]
  const key = Object.keys(routeMap).find(k => routeMap[k] === '/' + firstPart)
  
  if (key) {
    const rest = parts.slice(1).join('/')
    return rest ? `${key}/${rest}` : key
  }
  
  return path
}

export function decodePath(encoded) {
  if (!encoded) return '/login'
  
  const parts = encoded.split('/')
  const firstPart = parts[0]
  
  if (routeMap[firstPart]) {
    const rest = parts.slice(1).join('/')
    return rest ? `${routeMap[firstPart]}/${rest}` : routeMap[firstPart]
  }
  
  return '/' + encoded
}

export function getShortCode(path) {
  return reverseMap[path] || null
}